import React from 'react'
import moment from 'moment'
import { Input, Button } from 'semantic-ui-react'

export default class DateFields extends React.PureComponent {
  formatStartFrom = value =>
    Number(
      moment(value)
        .startOf('day')
        .format('x')
    )

  formatEndAt = value =>
    Number(
      moment(value)
        .endOf('day')
        .format('x')
    )

  render() {
    const { loading, onSearch, onFieldChange, startFrom, endAt } = this.props

    const start = moment(startFrom).format('YYYY-MM-DD')
    const end = moment(endAt).format('YYYY-MM-DD')

    return (
      <div style={{ display: 'inline-block' }}>
        <div className="capitalize" style={{ display: 'inline-block', marginRight: 10 }}>
          From
        </div>

        <Input
          type="date"
          name="from"
          value={start}
          disabled={loading}
          onChange={e => onFieldChange('startFrom', this.formatStartFrom(e.target.value))}
        />

        <div className="capitalize" style={{ display: 'inline-block', marginLeft: 10, marginRight: 10 }}>
          To
        </div>

        <Input
          type="date"
          name="to"
          value={end}
          disabled={loading}
          onChange={e => onFieldChange('endAt', this.formatEndAt(e.target.value))}
        />
        <Button disabled={loading} loading={loading} onClick={onSearch} style={{ marginLeft: 10 }}>
          Search
        </Button>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/luckyDrawWinners/components/DateRangeField.js